<div class="versioninfo container-fluid mt-5">
  Stand: {{ this.versionInfo?.datenstand }} | Version: {{ this.versionInfo?.version }}
</div>
